import Device from './Device';

export default Device;